import { loadingAnimation } from '../shared/loader';
import { observeDom, observeDomDisconnect } from '../shared/observer';
import { initSelfAsserted } from "./self-asserted";
import { initUnified } from "./unified";


/**
 * Container element where Microsoft B2C API nodes are injected
 *
 * @type {HTMLElement}
 */
export const b2cContainer = document.getElementById('api');


/**
 * Check whether b2cContainer HTMLElement exists
 *
 * @type {boolean}
 */
export const isB2cpage = !!b2cContainer;


/**
 * Name of the b2c page
 *
 * @type {string}
 */
export const b2cPage = !!b2cContainer ? b2cContainer.dataset.page : '';


/**
 * Name of the b2c template
 *
 * @type {string}
 */
export const b2cTemplate = !!b2cContainer ? b2cContainer.dataset.name : '';


/**
 * Check whether Microsoft B2C API nodes are injected
 *
 * @type {boolean}
 */
export let isB2cApiLoaded = false;


/**
 * B2C demo
 * @type {boolean}
 */
export const isB2cDemo = false;


/**
 * Use loader
 * @type {boolean}
 */
export const useLoader = false;


/**
 * Fake API change
 */
const fakeApiChange = (timeOut) => {
    setTimeout(() => {
        console.log('fake change');
        const fakeNode = document.createElement('span');
        b2cContainer.appendChild(fakeNode);
    }, timeOut);
};


/**
 * Setup B2C template logic
 */
export const initB2C = () => {
    if(useLoader) {
        const content = document.getElementById('content');
        const contentLoader = document.getElementById('content-loader');
        const stopAnimation = loadingAnimation(500, 1000, content, contentLoader);
    }

    const observeB2cApiConfig = {
        childList: true,
        subtree: true
    };

    /* Only initiate loadingAnimation and observeDom if API content is not injected jet */
    if (b2cContainer && b2cContainer.childNodes.length !== 0 && !isB2cDemo) {
        setupB2c();

        if(useLoader) {
            stopAnimation();
        }

        isB2cApiLoaded = true;
    }

    observeDom(b2cContainer, observeB2cApiConfig, observeB2cApi);

    function observeB2cApi(mutations, observer) {
        if (!isB2cApiLoaded) {
            setupB2c();

            if(useLoader) {
                stopAnimation();
            }
        }

        /**
         * Set to true in order to stop triggering script on api dom change
         * disconnect on detected change
         *
         * @type {boolean}
         */
        isB2cApiLoaded = true;
        observeDomDisconnect(observer, observeB2cApi);
    }

    if(isB2cDemo) {
        fakeApiChange(500);
    }
};


/**
 * Check which B2C logic to initialize
 */
export const setupB2c = () => {
    switch (b2cTemplate) {
        case 'SelfAsserted':
            initSelfAsserted();
            break;
        case 'Unified':
            initUnified();
            break;
        default:
    }
};
